/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Audiences_Default_DescriptionInputs */

const en_directory_taxonomy_audiences_default_description = /** @type {(inputs: Directory_Taxonomy_Audiences_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curated AI tools picked for this audience.`)
};

const zh_directory_taxonomy_audiences_default_description = /** @type {(inputs: Directory_Taxonomy_Audiences_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为该受众精选的 AI 工具。`)
};

/**
* | output |
* | --- |
* | "Curated AI tools picked for this audience." |
*
* @param {Directory_Taxonomy_Audiences_Default_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_audiences_default_description = /** @type {((inputs?: Directory_Taxonomy_Audiences_Default_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Audiences_Default_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_audiences_default_description(inputs)
	return zh_directory_taxonomy_audiences_default_description(inputs)
});
export { directory_taxonomy_audiences_default_description as "directory.taxonomy.audiences.default_description" }